import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { environment } from "environments/environment";
import { AdResponse } from "app/core/models/ad-response";

@Injectable()
export class AdService {

  constructor(private _httpClient: HttpClient) { }

  public getAds(filter: string, sortDirection: 'asc' | 'desc'| '', sortField: string, 
                      pageIndex: number, pageSize: number, activeFilters: Object[]): Observable<AdResponse> {
    // seteamos los filters
    let allStringFilterAux = [];
    activeFilters.forEach((item, index) => {
      if (item['value'] != null && item['value'] != '') {
        let stringFilterAux = [item['id'],item['value']];
        allStringFilterAux.push(stringFilterAux.join('::'));
      }
    });

    let queryFilter = allStringFilterAux.join('--');

    // Seteamos los params
    let params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString())
    .set('s', sortDirection?.toString().toUpperCase())
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/${environment.apiVersion}/ads`, {
      params: params
      }).pipe(
          // map(res =>  res["data"])
          map(res =>  <AdResponse>res)
      );
  }


  getAdStatus(): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/${environment.apiVersion}/ads/status`);
  }

  getAd(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/${environment.apiVersion}/ads/${id}`);
  }

  createAd(ad: any): Observable < any > {
      return this._httpClient.post(`${environment.apiUrl}/${environment.apiVersion}/ads`, ad);
  }

  editAd(ad: any, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/${environment.apiVersion}/ads/${id}`, ad);
  }

  deleteAd(id: string): Observable < any > {
      return this._httpClient.delete(`${environment.apiUrl}/${environment.apiVersion}/ads/${id}`);
  }

  lockAd(ad: any): Observable < any > {
    return this._httpClient.post(`${environment.apiUrl}/${environment.apiVersion}/ads/locks`, ad);
  }

  
}
